import { render, staticRenderFns } from "./OccurrenceFilterBar.vue?vue&type=template&id=047b53bb&scoped=true&"
import script from "./OccurrenceFilterBar.vue?vue&type=script&lang=js&"
export * from "./OccurrenceFilterBar.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceFilterBar.vue?vue&type=style&index=0&id=047b53bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047b53bb",
  null
  
)

export default component.exports